import { useEffect, useMemo, useState } from "react"
import ReactDatePicker from "react-datepicker"
import { useSelector } from "react-redux"
import DonutChart from "../components/custom/components/charts/apex/DonutChart"
import LineChart from "../components/custom/components/charts/apex/LineChart"
import api, { APIResponse } from "../config/api"
import { LocalFormatDate, getDate } from "../config/functions"
import { CategoryType } from "../redux/actions/categoryAction"
import { SalesPaymentModeTypes } from "../redux/actions/salesActions"
import { StoreState } from "../redux/store"
import { ReportSalesReturnItemType } from "./SalesReturnYearlyReport"


interface HourlySalesReturnData {
    id?: number
    // financeYear: string
    // branchId: number
    // invoiceType: string
    // invoiceTitle: string
    invoiceDate: string
    invoiceHour?: string
    // invoiceDay?: string
    // invoiceWeekNumber?: number
    // invoiceWeekDay?: number
    invoiceMonth?: number
    invoiceYear?: number
    invoiceNumber: number
    packNo: string
    salesReturnEntryNumber: number
    systemNo: string
    // repId?: number
    customerId: number
    // customerName: string
    // pointsEarned?: string
    // bankName: string
    // bankNumber: number
    paymentMode: SalesPaymentModeTypes
    billAmount?: string
    // disPercent?: string
    // disAmount?: string
    // add?: string
    // less?: string
    grandTotal?: string
    amtInWords?: string
    particulars?: string
    amtPaid?: string
    salesReturnItems: ReportSalesReturnItemType[]
}

const SalesReturnHourlyReport = () => {
    const categories = useSelector<StoreState, CategoryType[]>((state) => state.category)

    const d = new Date();
    d.setDate(d.getDate() - 1)
    const [dayOne, setDayOne] = useState<Date>(new Date(d))
    // const [dayOneError, setDayOneError] = useState<string>('')
    const [dayTwo, setDayTwo] = useState<Date>(new Date())
    // const [dayTwoError, setDayTwoError] = useState<string>('')

    const HoursArray = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24']

    const [hourlySalesReturnData, setHourlySalesReturnData] = useState<HourlySalesReturnData[]>([])

    // const handleFromYear: ChangeEventHandler<HTMLInputElement> = (e) => {
    //     setDayOne(e.target.value)
    //     setDayOneError('')
    // }

    // const handleToYear: ChangeEventHandler<HTMLInputElement> = (e) => {
    //     setDayTwo(e.target.value)
    //     setDayTwoError('')
    // }

    const CategorywiseDayOneSales = useMemo<{ cid: number, cname: string, sales: number }[]>(() => {
        let data: { cid: number, cname: string, sales: number }[] = [];
        const salesItemsData = hourlySalesReturnData?.filter(y => y.invoiceDate?.toString() === getDate(dayOne))?.map(m => m.salesReturnItems).flat(1);
        // console.log(salesItemsData);

        categories?.forEach(c => {
            const catSales = salesItemsData?.filter(si => si.categoryId?.toString() === c.id?.toString()).reduce((prev, curr) => {
                return prev + parseFloat(curr.totalAmount)

            }, 0)
            data.push({
                cid: c?.id ? c?.id : 0,
                cname: c?.name ? c?.name : '',
                sales: catSales
            })
        })
        // console.log(data);
        return data

    }, [hourlySalesReturnData, dayOne, categories])

    const CategorywiseDayTwoSales = useMemo<{ cid: number, cname: string, sales: number }[]>(() => {
        let data: { cid: number, cname: string, sales: number }[] = [];
        const salesItemsData = hourlySalesReturnData?.filter(y => y.invoiceDate?.toString() === getDate(dayTwo))?.map(m => m.salesReturnItems).flat(1);
        // console.log(salesItemsData);

        categories?.forEach(c => {
            const catSales = salesItemsData?.filter(si => si.categoryId?.toString() === c.id?.toString()).reduce((prev, curr) => {
                return prev + parseFloat(curr.totalAmount)

            }, 0)
            data.push({
                cid: c?.id ? c?.id : 0,
                cname: c?.name ? c?.name : '',
                sales: catSales
            })
        })
        // console.log(data);
        return data

    }, [hourlySalesReturnData, dayTwo, categories])

    useEffect(() => {

        if (dayOne !== undefined && dayTwo !== undefined) {
            api().get<APIResponse<HourlySalesReturnData[]>>(`salesReturn/dashboard/?dayOne=${getDate(dayOne)}&dayTwo=${getDate(dayTwo)}`).then((response) => {
                if (response.status === 200 && response.data.data) {
                    const result = response.data.data
                    // console.log(result);
                    setHourlySalesReturnData(result)
                }
            }).catch((error) => { })
        } else {
            setHourlySalesReturnData([])
        }
    }, [dayOne, dayTwo])

    // const colors = [COLORS.COLOR1, COLORS.COLOR2, COLORS.COLOR3, COLORS.COLOR4, COLORS.COLOR5, COLORS.COLOR6, COLORS.COLOR7, COLORS.COLOR8]

    return <>
        <div className="container">
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-8">
                            <h4>Hourly Sales</h4>
                        </div>
                        <div className="col-lg-4 hstack gap-3 text-end">
                            <div className="col-lg-3 ms-5">
                                <span className="dateInput">
                                    {/* <span><Feather.Calendar size={14} /></span> */}
                                    <ReactDatePicker
                                        id="DatePicker"
                                        // type="string"
                                        className="text-center fw-bold w-100"
                                        selected={dayOne}
                                        onChange={(date: any) => setDayOne(date)}
                                        calendarClassName=""
                                        dateFormat="dd/MM/yyyy"
                                    // yearItemNumber={4}
                                    //     required
                                    />
                                </span>

                                {/* <FormInput
                                name='dayOne'
                                label='From Year'
                                labelClassName="required"
                                value={dayOne}
                                className="mt-2 fs-5"
                                onChange={handleFromYear}
                                errorText={dayOneError}
                                type="date"
                            /> */}
                            </div>
                            <div className="col-lg-3">
                                <span className="dateInput">
                                    <ReactDatePicker
                                        id="DatePicker"
                                        // type="string"
                                        className="text-center fw-bold w-100"
                                        selected={dayTwo}
                                        onChange={(date: any) => setDayTwo(date)}
                                        dateFormat="dd/MM/yyyy"
                                        yearItemNumber={4}
                                    //     required
                                    />
                                </span>

                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            {
                                // <BarChart
                                //     // datasets={[
                                //     //     { label: 'Portfolio 1', data: [11, 10, 34, 56, 12, 44, 55, 56, 89, 35, 78, 67], backgroundColor: COLORS.COLOR1, borderColor: COLORS.COLOR1 },
                                //     //     { label: 'Portfolio 2', data: [51, 70, 84, 16, 56, 78, 12, 45, 56, 89, 34, 56], backgroundColor: COLORS.COLOR2, borderColor: COLORS.COLOR2 }
                                //     // ]}
                                //     datasets={(() => {
                                //         let ydata: { name: string; data: number[] }[] = []

                                //         MonthlyFilteredData.forEach((y, i) => {
                                //             const index = portfolioOption.findIndex(p => p.id !== undefined && p.id.toString() === y.portfolio.toString())
                                //             const name = portfolioOption[index]?.name

                                //             // let data = y.record.map(d => parseFloat(d.sales))
                                //             // if (data.length > 0) {
                                //             //     ydata.push({
                                //             //         name: name,
                                //             //         data: data
                                //             //     })
                                //             // }
                                //             let data2: number[] = []
                                //             let d1 = y.record
                                //             yearFilter.map(f => f).sort().forEach(yr => {
                                //                 var yrs = d1.map(d => d.transyear)
                                //                 if (yrs.includes(yr)) {
                                //                     let obj = d1.find(f => f.transyear === yr)
                                //                     data2.push(obj?.sales ? parseFloat(obj.sales) : 0)
                                //                 } else data2.push(0)
                                //             })

                                //             if (data2.length > 0) {
                                //                 ydata.push({
                                //                     name: name,
                                //                     data: data2
                                //                 })
                                //             }
                                //         })
                                //         return ydata
                                //     })()
                                //         //     MonthlyFilteredData.map((y, i) => {
                                //         //     const index = portfolioOption.findIndex(p => p.id !== undefined && p.id.toString() === y.portfolio.toString())
                                //         //     const name = portfolioOption[index]?.name

                                //         //     return {
                                //         //         name: name,
                                //         //         data: y.record.map((r) => {
                                //         //             return parseFloat(r?.sales)
                                //         //         }),
                                //         //     }
                                //         // })
                                //     }
                                //     // labels={yearFilter.map(y => y.toString()).sort() || []}
                                //     labels={(() => {
                                //         const years: string[] = []
                                //         MonthlyFilteredData?.forEach((yr, i) => {
                                //             yr.record.forEach((r, i) => {
                                //                 years.push(r.transyear.toString())
                                //             })
                                //         })
                                //         return years.filter(onlyUnique)
                                //     })()}

                                //     // labels={MonthlyData.at(0)?.record.map(r => r.transyear.toString()) || []}
                                //     colors={[colors[0], colors[1], colors[2], colors[3], colors[4], colors[5], colors[6], colors[7]]}
                                //     title={''}
                                // />
                            }

                            <LineChart
                                // datasets={[
                                //     { name: LocalFormatDate(dayOne.toDateString()), data: [54, 64, 52, 43, 22, 60, 32, 87, 13, 14, 34, 45, 54, 0, 0, 34, 34, 52, 43, 22, 20, 32, 87, 13] },
                                //     { name: LocalFormatDate(dayTwo.toDateString()), data: [22, 20, 32, 87, 13, 14, 34, 45, 54, 0, 0, 4, 64, 52, 43, 22, 60, 32, 87, 13, 14, 34, 45, 13] },

                                //     // { name: dayTwo?.getFullYear()?.toString(), data: [ToYearSales] }
                                // ]}
                                datasets={(() => {
                                    let monthData: { name: string, data: number[] }[] = []
                                    let days = [dayOne, dayTwo]
                                    days.forEach(day => {

                                        const fdata = hourlySalesReturnData?.filter(y => y.invoiceDate?.toString() === getDate(day))
                                        // console.log(fdata);
                                        let data: number[] = []
                                        HoursArray.forEach(hr => {

                                            const val = fdata?.filter(f => f.invoiceHour?.toString() === hr)?.reduce((p, c) => {
                                                return p + (c?.grandTotal ? parseFloat(c?.grandTotal) : 0)
                                            }, 0)
                                            data.push(val)
                                        })
                                        monthData.push({
                                            name: LocalFormatDate(day?.toDateString()),
                                            data: data
                                        })
                                    })

                                    return monthData
                                })()}

                                labels={HoursArray}
                                colors={['#00B9E3', '#FF4560']}
                                // colors={[colors[0], colors[1], colors[2], colors[3], colors[4], colors[5], colors[6], colors[7]]}
                                title=""
                            />
                        </div>

                        <div className="col-lg-3">
                            <DonutChart
                                // datasets={[24, 45, 45, 56, 88]}
                                // labels={["Men's wear", "Women's wear", "Kid's wear", "Dhotis", "Toys"]}
                                datasets={CategorywiseDayOneSales.map(fm => fm.sales)}
                                labels={CategorywiseDayOneSales.map(fm => fm.cname)}
                                colors={['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#DC2AAC']}
                                title={LocalFormatDate(dayOne?.toDateString())}
                            />
                        </div>
                        <div className="col-lg-3">
                            <DonutChart
                                datasets={CategorywiseDayTwoSales.map(fm => fm.sales)}
                                labels={CategorywiseDayTwoSales.map(fm => fm.cname)}
                                colors={['#FC89AC', '#7ED957', '#FF914D', '#00B9E3', '#E192FF', '#8CA5F7']}
                                title={LocalFormatDate(dayTwo?.toDateString())}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div >

    </>
}
export default SalesReturnHourlyReport